export default __webpack_public_path__ + "static/media/i-dados.e9451d99.png";